import langDocumentFilesFilters from './langs/langDocumentFilesFilters';
import langDocumentFiles from './langs/langDocumentFiles';
import langDocumentFilesTable from './langs/langDocumentFilesTable';
import langDocumentType from './langs/langDocumentType';
import langDocumentFile from './langs/langDocumentFile';
import langDocumentExpertise from './langs/langDocumentExpertise';
import langDocumentSearch from './langs/langDocumentSearch';
import langDocumentAccessTable from './langs/langDocumentAccessTable';
import langDocumentDownloadLogTable from './langs/langDocumentDownloadLogTable';
import langDocumentTypeSub from './langs/langDocumentTypeSub';
import langDocumentNotification from './langs/langDocumentNotification';

const DocumentLangs = [
	langDocumentFiles,
	langDocumentFilesFilters,
	langDocumentFilesTable,
	langDocumentType,
	langDocumentTypeSub,
	langDocumentFile,
	langDocumentExpertise,
	langDocumentAccessTable,
	langDocumentSearch,
	langDocumentDownloadLogTable,
	langDocumentNotification,
];

export default DocumentLangs;
